import {$qsAll} from '../../../@shared/ts/dom';
import {AbstractStripePayment, type ConfirmResult, type TokenResult} from './abstract/class-abstract-stripe-payment';
import {onCheckoutUpdate, FormFields} from '../checkout';
import {billingDetails} from './stripe';

class StripeAfterPayPayment extends AbstractStripePayment {
	public override init() {
		// Attach listener for switching afterpay to clearpay and vice versa
		onCheckoutUpdate(() => {
			let title = 'afterpay';
			switch (FormFields.billing.country.get()) {
				case 'GB':
				case 'ES':
				case 'FR':
				case 'IT': {
					title = 'clearpay';
				}
			}

			$qsAll('#payment-methods-container img[gateway="peachpay_stripe_afterpay"]', el => {
				const srcComponents = el.getAttribute('src')?.split('/');
				const currentSrc = srcComponents?.splice(0, srcComponents.length - 1).join('/');
				el.setAttribute('src', currentSrc + '/' + title.toLowerCase() + '-full-color.svg');
			});
		});
	}

	public gatewayId() {
		return 'peachpay_stripe_afterpay';
	}

	public async tokenize(): Promise<TokenResult> {
		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			type: 'afterpay_clearpay',
			billing_details: billingDetails(),
		});

		if (error) {
			const message = error.message ?? 'Failed to tokenize payment method.';

			return [null, {
				paymentStatus: 'creationfailed',
				note: message,
			}];
		}

		if (!paymentMethod?.id) {
			return [null, {
				paymentStatus: 'creationfailed',
				note: 'Failed to tokenize payment method.',
			}];
		}

		return [paymentMethod.id, {}];
	}

	public async confirm(clientSecret: string, intermediateURL?: string | undefined): Promise<ConfirmResult> {
		const {paymentIntent, error} = await this.stripe.confirmAfterpayClearpayPayment(clientSecret, {return_url: intermediateURL});

		if (error) {
			const message = error.message ?? 'Failed to confirm payment.';
			return [null, {
				note: message,
			}];
		}

		if (paymentIntent) {
			return ['success', {}];
		}

		return [null, {}];
	}
}

export {
	StripeAfterPayPayment,
};
